document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const focused = document.activeElement;
  const openMenus = [...document.querySelectorAll('.ravn-shop-menu[open], .ravn-mobile-nav[open]')];
  const owner = openMenus.find(menu => menu.contains(focused));
  openMenus.forEach(menu => { menu.open = false; });
  owner?.querySelector('summary')?.focus();
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.ravn-shop-menu[open], .ravn-mobile-nav[open]').forEach(menu => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  });
});
document.addEventListener('focusin', (event) => {
  document.querySelectorAll('.ravn-desktop-nav .ravn-shop-menu[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
